import { ObjectDetailsComponent, ObjectDetailsTypes } from './../dialogs/object-details/object-details.component';
import { ProductsComponent, ProductTreeType } from './../products/products.component';
import { Subscription, of } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { LanguagePack } from 'src/app/model/CatalogProduct';
import { AvailableHotfix, AvailableHotfixRequest, DiscoveredProduct, EnableProductResult, PatchExt, ProductExt, ProductInstance, QuickAnalysisResult } from 'src/app/model/Product';
import { Events, MsgPayLoad, WebsocketService } from 'src/app/service/websocket.service';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { ColumnType, DataTableColumn, DataTableRow } from '../controls/datatable/datatable.component';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from 'src/app/service/event.service';
import { DataService } from 'src/app/service/data.service';
import { Agent } from 'src/app/model/Agent';
import { ProductDataType } from '../products/products.component';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { Modal } from '../controls/modal/modal.service';
import { ActivityService } from 'src/app/service/activity.service';
import { ActivityTask, ActivityTaskType } from 'src/app/model/TaskStatus';
import { Utils } from 'src/app/utils';
import { UserInfo } from 'src/app/model/User';
import { CookieService } from 'ngx-cookie-service';
import { ModalMessageComponent, ModalMessageType } from '../controls/modal-message/modal-message.component';
import { catchError, finalize, tap } from 'rxjs/operators';
import { PatchSelectionComponent } from '../dialogs/patch-selection/patch-selection.component';
import { DownloadType } from 'src/app/model/DownloadStatus';
import { Tab, TabColor } from '../controls/tabs/tabs.component';
import { FileSizePipe } from 'src/app/pipe/file-size.pipe';
import { ModalConfig } from '../controls/modal/modal-config';
import { AgentService } from 'src/app/service/agent.service';
import { TranslationUtils } from 'src/app/app-translation-utils';
import { SolutionService } from 'src/app/service/solution.service';
import { DownloadItem } from '../products-overview/products-overview.component';

enum UpdateTab {
  PATCHES, LANGUAGES
}

enum ComponentTab {
  COMPONENTS
}

@Component({
    selector: 'app-products-updates',
    templateUrl: './products-updates.component.html',
    styleUrls: ['./products-updates.component.css'],
    standalone: false
})
export class ProductsUpdatesComponent extends ProductsComponent implements OnInit {

  availablePatches: PatchExt[];
  selectedComponentVersion: string;
  activeUpdate:PatchExt;
  activeProduct:ProductExt;
  activeComponent: string;
  TabColor = TabColor;
  activeTab: UpdateTab = UpdateTab.PATCHES;
  activeComponentTab: ComponentTab = ComponentTab.COMPONENTS;
  patchesTab = new Tab('product-updates-patches-tab', $localize`Patches`, 0, false);
  languageTab = new Tab('product-updates-languages-tab', $localize`Languages`, 0, false);
  tabs: Tab[] = [this.patchesTab, this.languageTab];
  componentTab = new Tab('components-tab', $localize`Components`, 0, false);
  componentTabs: Tab[] = [this.componentTab];
  UpdateTab = UpdateTab;
  ComponentTab = ComponentTab;
  host:string;
  isOnlineMode:boolean = true;
  hotfixLoading: boolean = false;
  hotfixTableCols: DataTableColumn[] = [];
  hotfixTableRows: DataTableRow[] = [];
  componentsLoading: boolean = true;
  componentTableCols: DataTableColumn[] = [];
  componentTableRows: DataTableRow[] = [];

  itemsToDownload:DownloadItem = new DownloadItem();
  availableUpdates:PatchExt[] = [];
  langPackTableCols: DataTableColumn[] = [];
  langPackTableRows: DataTableRow[] = [];
  productGroupId: number;
  binaryuid: string;
  agents:Agent[] = [];
  discoveredProduct:DiscoveredProduct[] = [];
  isAgentOnline:boolean = true;
  isMasterSystemSupported: boolean = false;
  isQuickAnalysisRequired:boolean = false;
  isMasterSystemSelected = true;
  productId:number;
  setupId:string;
  isProxyRequired:boolean;
  hotfixes:AvailableHotfix;
  dependentPatches:PatchExt[] = [];
  supercededPatches:PatchExt[] = [];
  quickAnalysisResult:QuickAnalysisResult;
  
  overrideHotfixSelectAll:boolean;
  isExportBtnClicked:boolean = false;
  recountSelectedRow:boolean = false;

  isReload:boolean = false;
  currEnvId:number;

  platform: string;

  summaryVersion: string;
  summaryStatus: string;
  summaryDescription: string;
  summarySize: string;
  summaryReleaseDate: string;
  summaryZeroDowntime: boolean;

  productDetailsTitle:string;
  headerTitle:string;
  width: string = '0px';

  requestFailed: boolean = false;
  requestErrorMessage: string;

  downloadedPatches:PatchExt[] = [];
  isRequestingHotfixes: boolean = false;
  supportsZeroDowntime: boolean = false;

  constructor(protected eventService: EventService,
    protected authService:AuthenticationService,
    protected siService:SoftwareInventoryService,
    protected dataService:DataService,
    protected wsService: WebsocketService,
    protected router: Router,
    protected modal: Modal,
    protected activityService: ActivityService,
    protected route: ActivatedRoute,
    private cookieSrv: CookieService,
    protected agentService: AgentService,
    protected solutionService:SolutionService) {
    super(eventService, authService, siService, dataService, wsService, router, modal, activityService, solutionService);
  }

  ngOnInit(): void {
    this.isOnlineMode = this.authService.getLoggedInUser().settings.isOnlineMode;
    this.initTableCols();
    this.routeSubscription = this.route.params.subscribe(params => {
      this.productId = +params['productId'];
      this.binaryuid = params['binaryuid'];
      this.isLoading = true;
      this.isReload = this.productId !== undefined;
    });

    this.dataSubscription = this.dataService.getData().subscribe((data:any) => {
      if(data && data.type == ProductDataType.AgentManifest) {
        this.isAgentManifestUpdating = data.isAgentManifestUpdating;
      } else if (data && data.type == ProductDataType.DownloadStarted) {
        this.setDownloadInProgress();
      } else if(data && (data.type == ProductDataType.General || data.type == ProductDataType.Updates || data.type == ProductDataType.QuickAnalysis)){
        this.solutionInfo = data.solutionInfo;
        this.isManifestUpdating = this.solutionInfo.manifestStatus.isUpdating;
        this.discoveredProduct = data.discoveredProductGroup;
        this.agents = this.solutionInfo.currentEnvironment.agents;
        this.isAgentOnline = data.isAgentOnline;
        if(!this.isAgentOnline){
          this.isLoading = false;
        }

        if(data.quickAnalysisResult){
          this.quickAnalysisResult = data.quickAnalysisResult;
        }
        
        let foundProdGroup:DiscoveredProduct;
        let foundProduct:ProductExt;

        for(let i = 0; i < this.discoveredProduct.length; i++) {
          for(let j = 0; j < this.discoveredProduct[i].products.length; j++){
            if(this.discoveredProduct[i].products[j].id == this.productId){
              foundProduct = this.discoveredProduct[i].products[j];
              if(foundProduct.supportHotfix){
                this.isQuickAnalysisRequired =  this.quickAnalysisResult ? !this.quickAnalysisResult.isValid : !foundProduct.isQuickAnalysisValid;
              } else {
                this.hotfixLoading = false;
              }
              break;
            }
          }
          if(foundProduct){
            foundProdGroup = this.discoveredProduct[i];
            break;
          }
        }

        if(foundProduct){
          this.productGroupId = foundProduct.groupId;
          this.platform = foundProduct.platform;
          let foundProd:ProductExt[] = [];
          this.isMasterSystemSupported = (foundProduct.pluginId == "com.opentext.sc.agent.plugin.cs");
          
          this.dataService.sendData({type: ProductDataType.SelectTree, 
            select: {type: ProductTreeType.UPDATE, 
                    binaryuid: this.binaryuid,
                    productId: this.productId,
                    productGroupId: this.productGroupId}}
            );
          for(let i = 0; i < this.discoveredProduct.length; i++) {
            foundProd = (this.discoveredProduct[i].products.filter((prod:ProductExt) => {
              return prod.id == this.productId;
            }));
            if(foundProd.length > 0){
              break;
            }
          }

          if (foundProd[0].availablePatches.length > 0){
            this.activeProduct = foundProd[0];
            this.availablePatches = foundProd[0].availablePatches;

            if(foundProd[0].isMultiComponent ){
              this.resetComponentInformation();
              this.loadComponentVersions(foundProd[0]);
            }else{
              this.initActiveUpdate(false);
            }

            if(this.isQuickAnalysisRequired){
              this.isReload = this.quickAnalysisResult !== undefined || (this.isReload || this.currEnvId != this.solutionInfo.currentEnvironment.id);
            }else{
              this.isReload = this.isReload || this.currEnvId != this.solutionInfo.currentEnvironment.id;
            }

            if (foundProd[0].zeroDownTimeMinVersion !== undefined && foundProd[0].zeroDownTimeMinVersion !== "") {
              let newVersionSupport = Utils.isVersionOrHigher(foundProd[0].zeroDownTimeMinVersion, foundProd[0].version);
              if(newVersionSupport !== this.supportsZeroDowntime) {
                this.supportsZeroDowntime = newVersionSupport;
                this.initTableCols();
              }
            }
    
            if(this.isReload){
              this.initView();
              this.isReload = false;
            }
          }else if(this.quickAnalysisResult && !this.quickAnalysisResult.isValid){
            this.isQuickAnalysisRequired = true;
            this.initView();
            this.isLoading = false;
          //up to date
          }else if(foundProd.length > 0 && !foundProd[0].supportHotfix){
            this.productDetailsTitle = $localize`Download Updates for ${foundProd[0].name}`;
            this.dataService.sendData({type: ProductDataType.Title, title: this.productDetailsTitle});
            this.activeUpdate = undefined;
            this.isLoading = false;
          }
        }else{
          this.router.navigate(['products/overview']);  
        }
      }else if(isNaN(this.productGroupId)){
        this.router.navigate(['products/overview']);
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if(msg.eventType == Events.AvailableHotfixes) {
        if(this.isPendingTransaction(msg.headers.transactionId, true)){
          this.itemsToDownload.patches = [];
          this.hotfixTableRows = [];
          let tmpHotfixTableRows = [];
          this.hotfixes = JSON.parse(msg.body.msg);
          this.dependentPatches = [];
          this.supercededPatches = [];
          //sort by patch number in DESC order
          this.hotfixes.availableHotfixes = this.hotfixes.availableHotfixes.sort((a,b) => +a.details.id > +b.details.id ? -1 : +a.details.id == +b.details.id ? 0 : 1);

          //add rows
          this.hotfixes.availableHotfixes.forEach((patch:PatchExt) => {
            //filter
            if(patch.details && 
              patch.details.isPublic && // is public
              !patch.details.retired && // not retired
              !patch.isSupersededDownloaded //superseded hotfix is not downloaded
              ){
                let isValidDownloadURL:boolean = patch.details.downloadURL && patch.details.downloadURL !== '';
                let isDownloaded:boolean = patch.status === 'COMPLETE' || patch.status === 'INSTALLED';
                let actionMenus:ActionMenuItem[] = [new ActionMenuItem("Details", $localize`Details`, ActionMenuIcon.DETAILS, patch, false, true)];

                if(isDownloaded || patch.status === 'ERROR'){
                  actionMenus.push(new ActionMenuItem("Delete", $localize`Delete`, ActionMenuIcon.DELETE, {patch: patch}, true, true));
                }

                let row = new DataTableRow({name: patch.name, description: patch.description,
                                            modules: Utils.getModuleList(patch.details),
                                            zero: patch.details.zero ? $localize`Supported` : "",
                                            status: Utils.getDownloadStatus(patch),
                                            url: patch.details.downloadURL,
                                            patch: patch},
                                            actionMenus, false,
                                            !isDownloaded && isValidDownloadURL ? true : false, false);
                if(isDownloaded || !isValidDownloadURL){
                  row.disableCheckbox = true;
                }
                tmpHotfixTableRows.push(row);
              }
          });
          
          this.checkHotfixDependency();

          //add to download items
          tmpHotfixTableRows.forEach((row:DataTableRow) => {
            this.updateItemsToDownload(row);
          });
          this.overrideHotfixSelectAll = true;
          this.patchesTab.count = tmpHotfixTableRows.length;
          
          this.hotfixTableRows = tmpHotfixTableRows;
          this.isRequestingHotfixes = false;
          this.hotfixLoading = false;
        }
      }else if(msg.eventType == Events.ActivityCapabilities){
        if(this.isPendingTransaction(msg.headers.transactionId, true)){
          this.activityCapabilities = JSON.parse(msg.body.msg);

          this.activityCapabilities.tasks.forEach((task:ActivityTask) => {
            //set validate host task to success
            if(task.type == ActivityTaskType.VALIDATE_HOST){
              task.completed = true;
              task.success = true;
              task.isCurrentTask = false;
            //set validate comm task to success and current task
            }else if(task.type == ActivityTaskType.VALIDATE_COMMUNICATIONS){
              task.completed = true;
              task.success = true;
              task.isCurrentTask = true;
            }else{
              task.isCurrentTask = false;
            }
          });

          this.analyzeMasterSystem(this.solutionInfo, this.activityCapabilities, this.activeProduct);
        }
      }else if(msg.eventType == Events.EnableProduct) {
        let enableProdResult:EnableProductResult = msg.body;
        this.isReload = enableProdResult.isEnabled;
      }else if(msg.eventType == Events.DownloadCompleted){
        if(msg.body.langPackId > 0){
          let deletedLangPack:LanguagePack[] = this.itemsToDownload.removeDownloadedLangPackByBId(msg.body.binaryuid);
          if(deletedLangPack.length > 0){
            this.setLangPackDownloadComplete(deletedLangPack[0], msg.body.status);
          }else{
            this.setLangPackDownloadCompleteByBUId(msg.body.binaryuid, msg.body.status);
          }
        }else if(msg.body.hotfixId > 0){
          let deletedPatch:PatchExt[] = this.itemsToDownload.removeDownloadedPatchesByBId(msg.body.binaryuid);
          if(deletedPatch.length > 0){
            this.setPatchDownloadComplete(deletedPatch[0], msg.body.status);
          }else{
            this.setPatchDownloadCompleteByBUId(msg.body.binaryuid, msg.body.status);
          }
        }else if(msg.body.updateId > 0){
          if(msg.body.status == 'COMPLETE'){
            let deletedPatch:PatchExt[] = this.itemsToDownload.removeDownloadedUpdatesByBId(msg.body.binaryuid);
            if(deletedPatch.length > 0){
              deletedPatch[0].status = msg.body.status;
            }
          }else{
            this.itemsToDownload.setDownloadUpdateStatusByBId(msg.body.binaryuid, msg.body.status);
          }
          this.summaryStatus = msg.body.status;
        }else{
          //update from the catalog
          let deletedPatch: PatchExt[] = this.itemsToDownload.removeDownloadedPatchesByBId(msg.body.binaryuid);
          if (deletedPatch.length > 0) {
            deletedPatch[0].status = msg.body.status;
            this.setComponentPatchDownloadComplete(deletedPatch[0], msg.body.status);
          } else {
            this.setUpdateDownloadComplete(msg.body)
          }
        }
      }else if(msg.eventType == Events.QuickAnalysis){
        if(this.isPendingTransaction(msg.headers.transactionId, true)){
          this.quickAnalysisResult = JSON.parse(msg.body.msg);
        }
      }else if(msg.eventType == Events.SettingsConnectionMode){
        this.isOnlineMode = this.authService.getLoggedInUser().settings.isOnlineMode;
        this.initTableCols();
      } else if (msg.eventType == Events.ManifestUpdateStarted) {
        this.isManifestUpdating = true;
      } else if (msg.eventType == Events.ManifestUpdateComplete) {
        this.reloadAfterManifestUpdate();
      } else if (msg.eventType == Events.AgentManifestComplete) {
        this.isAgentManifestUpdating = false;
      } else if(msg.eventType == Events.AvailablePatches){
        this.getAvailableHotfixes();
      }
    });
  }

  ngOnDestroy() {
    if (this.routeSubscription != undefined) {
      this.routeSubscription.unsubscribe();
    }
    if (this.dataSubscription != undefined) {
      this.dataSubscription.unsubscribe();
    }
    if (this.eventMessageSubscription != undefined) {
      this.eventMessageSubscription.unsubscribe();
    }
  }

  checkHotfixDependency():void {
    this.supercededPatches = [];
    this.dependentPatches = [];
    
    //check dependency
    this.hotfixTableRows.forEach((row:DataTableRow) => {
      let patches:PatchExt[] = this.checkPatchDependencyRequirement(this.hotfixTableRows, this.hotfixes.availableHotfixes, row.selected, row.data.patch, true);
      if(patches.length > 0){
        patches.forEach((patch:PatchExt) => {
          let index:number = this.dependentPatches.findIndex(depenentPatch => depenentPatch.details.id === patch.details.id);
          if(index < 0){
            this.dependentPatches.push(patch);
          }
        })
      }
    });
    setTimeout(() => {
      this.setSupersededInfo();
    }, 0);
  }

  setSupersededInfo(): void {
    this.hotfixTableRows.forEach((row:DataTableRow) => {
      let patches: PatchExt[] = this.checkPatchSupersededByRequirement(this.hotfixTableRows, this.hotfixes.availableHotfixes, row.selected, row, true);
      if(patches.length > 0){
        let index:number = this.supercededPatches.findIndex(supercededPatch => supercededPatch.details.id === row.data.patch.details.id);
        if(index < 0){
          this.supercededPatches.push(row.data.patch);
        }
      }
    });
  }

  onSelectedTabChange(selectedIndex: number) {
    this.activeTab = selectedIndex;
  }

  hotfixRowClicked(row:DataTableRow): void {
    let dependentPatches:PatchExt[] = this.checkPatchDependencyRequirement(this.hotfixTableRows, this.hotfixes.availableHotfixes, row.selected, row.data.patch, true, true);
    let supersededByPatches:PatchExt[] = this.checkPatchSupersededByRequirement(this.hotfixTableRows, this.hotfixes.availableHotfixes, row.selected, row, true, false, false);
    let supersedesPatches:PatchExt[] = this.checkPatchSupersedesRequirement(this.hotfixTableRows, this.hotfixes.availableHotfixes, row.selected, row, true);

    if(dependentPatches.length > 0 || supersededByPatches.length > 0){
      if(supersededByPatches.length > 0){
        supersededByPatches.push(row.data.patch);
        supersededByPatches = supersededByPatches.sort((a,b) => +a.details.id > +b.details.id ? -1 : +a.details.id == +b.details.id ? 0 : 1);
      }

      if(dependentPatches.length > 0){
        dependentPatches = dependentPatches.sort((a,b) => +a.details.id > +b.details.id ? -1 : +a.details.id == +b.details.id ? 0 : 1);
      }

      const sub: Subscription =
        this.modal.open(PatchSelectionComponent, {
          data: { dependentPatches: dependentPatches, supersededByPatches: supersededByPatches, patch: row.data.patch },
          id: 'otsc-products-patch-details-dialog'
        }).afterClosed.subscribe((result: any) => {
          if (result.isConfirmed) {
            if (supersededByPatches.length > 0 && result.supersededPatch) {
              supersededByPatches.forEach((patch: PatchExt) => {
                let row: DataTableRow = this.getRowByPatchId(this.hotfixTableRows, patch);
                row.selected = patch.details.id === result.supersededPatch.details.id;
                row.disableCheckbox = patch.details.id !== result.supersededPatch.details.id;
                this.updateItemsToDownload(row);
              });

              //disable supersedes patches
              supersedesPatches.forEach((patch: PatchExt) => {
                let row: DataTableRow = this.getRowByPatchId(this.hotfixTableRows, patch);
                if (row) {
                  row.disableCheckbox = true;
                  row.selected = false;
                }
              });
            }
            if (dependentPatches.length > 0) {
              this.updateItemsToDownload(row);
              dependentPatches.forEach((patch: PatchExt) => {
                let patchRow: DataTableRow = this.getRowByPatchId(this.hotfixTableRows, patch);
                if (patchRow) {
                  this.updateItemsToDownload(patchRow);
                }
              });
            }
          } else {
            row.selected = false;
            //unselect dependent patches
            dependentPatches.forEach((patch: PatchExt) => {
              let row: DataTableRow = this.getRowByPatchId(this.hotfixTableRows, patch);
              if (row) {
                row.disableCheckbox = false;
                row.selected = false;
              }
            });
            //unselect superseded patches
            supersededByPatches.forEach((patch: PatchExt) => {
              let row: DataTableRow = this.getRowByPatchId(this.hotfixTableRows, patch);
              if (row) {
                row.disableCheckbox = false;
                row.selected = false;
              }
            });
          }
          this.recountSelectedRow = !this.recountSelectedRow;
          sub.unsubscribe();
        });
    }else{
      //check superseded dependent patches
      if(supersedesPatches.length > 0 && !row.selected){
        supersedesPatches.forEach((patch:PatchExt) => {
          this.checkPatchDependencyRequirement(this.hotfixTableRows, this.hotfixes.availableHotfixes, false, patch, true);
        });
      }
      this.updateItemsToDownload(row);
    }
  }

  langpackRowClicked(row:DataTableRow): void {
    this.updateItemsToDownload(row);
  }

  selectAllHotfix(rows:DataTableRow[]): void {
    let isSelected:boolean = false;
    if(rows.length > 0){
      let enabledRows:DataTableRow[] = rows.filter((row:DataTableRow) => {
        return !row.disableCheckbox;
      })

      if(enabledRows.length > 0){
        isSelected = enabledRows[0].selected;
      }
    }
    this.checkHotfixDependency();
    //add to download items
    this.hotfixTableRows.forEach((row:DataTableRow) => {
      //clear all selection
      if(!isSelected){
        row.selected = false;
        let disabledRows:DataTableRow[] = rows.filter((row:DataTableRow) => {
          return row.disableCheckbox;
        });

        if(disabledRows.length > 0) {
          disabledRows.forEach((row:DataTableRow) => {
            let isValidDownloadURL: boolean = row.data.patch.details.downloadURL && row.data.patch.details.downloadURL !== '';
            let isDownloaded: boolean = row.data.patch.status === 'COMPLETE' || row.data.patch.status === 'INSTALLED';
            if(isValidDownloadURL && !isDownloaded){
              row.disableCheckbox = false;
            }
          });
        }
      }
      this.updateItemsToDownload(row);
    });
    this.overrideHotfixSelectAll = isSelected;
    this.recountSelectedRow = !this.recountSelectedRow;
  }

  selectAllLangPack(rows:DataTableRow[]): void {
    rows.forEach((row:DataTableRow) => {
      this.updateItemsToDownload(row);
    });
  }

  actionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "Details"){
      this.openDetails(event.data[0]);
    } else if(event.name === "Delete"){
      const sub: Subscription =
        this.modal.open(ModalMessageComponent, {
          data: {
            title: $localize`Delete`,
            message: event.data.length === 1 ? $localize`${event.data[0].patch.name} will be deleted. Delete selected item?` :
              $localize`${event.data.length} items will be deleted. Delete selected items?`,
            primaryBtn: $localize`Delete`,
            secondaryBtn: $localize`Cancel`,
            width: '350px'
          },
          id: 'otsc-products-delete-item-msg'
        }
        ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
          if (isPrimaryBtnClicked) {
            let uids: string[] = [];

            event.data.forEach((data) => {
              uids.push(data.patch.details.binaryuid);
            });

            this.siService.removeDownloadFiles(uids).pipe(
              tap(resp => {
                let msg = new MsgPayLoad(undefined, {
                  message: event.data.length === 1 ? $localize`${event.data[0].patch.name} was successfully deleted.` :
                    $localize`${event.data.length} items were successfully deleted.`
                });
                msg.setEvent(Events.SuccessMsg);

                Utils.addHeaderMessageBanner(this.eventService, msg);
              }),
              finalize(() => {
                this.initView();
              })
            ).subscribe();
          }
          sub.unsubscribe();
        });
    }
  }

  langActionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "Details"){
      this.openDetails(event.data[0]);
    } else if(event.name === "Delete"){
      const sub: Subscription =
        this.modal.open(ModalMessageComponent, {
          data: {
            title: $localize`Delete`,
            message: event.data.length === 1 ? $localize`${event.data[0].langPack.langName} will be deleted. Delete selected item?` :
              $localize`${event.data.length} items will be deleted. Delete selected items?`,
            primaryBtn: $localize`Delete`,
            secondaryBtn: $localize`Cancel`,
            width: '350px'
          },
          id: 'otsc-products-delete-item-msg'
        }
        ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
          if (isPrimaryBtnClicked) {
            let uids: string[] = [];

            event.data.forEach((data) => {
              uids.push(data.langPack.binaryuid);
            });

            this.siService.removeDownloadFiles(uids).pipe(
              tap(resp => {
                uids.forEach((uid:string) =>{
                  let deletedLangPack:LanguagePack[] = this.itemsToDownload.removeDownloadedLangPackByBId(uid);
                  if(deletedLangPack.length > 0){
                    this.setLangPackDownloadComplete(deletedLangPack[0], 'AVAILABLE');
                  }else{
                    this.setLangPackDownloadCompleteByBUId(uid, 'AVAILABLE');
                  }
                });

                let msg = new MsgPayLoad(undefined, {
                  message: event.data.length === 1 ? $localize`${event.data[0].langPack.langName} was successfully deleted.` :
                    $localize`${event.data.length} items were successfully deleted.`
                });
                msg.setEvent(Events.SuccessMsg);

                Utils.addHeaderMessageBanner(this.eventService, msg);
              }),
              finalize(() => {
                this.dataService.sendData({ type: ProductDataType.Reload });
              })
            ).subscribe();
          }
          sub.unsubscribe();
        });
    }
  }

  analyzeMasterSystemClicked(): void {
    this.getEnableProductCapabilities(this.solutionInfo, this.activityCapabilities, this.activeProduct);
  }

  download(): void {
    let user: UserInfo = this.authService.getLoggedInUser();
    this.isOnlineMode = user.settings.isOnlineMode;
    this.isProxyRequired = user.settings.proxyPrompt;

    Utils.startDownload(this.isProxyRequired, this.activeProduct.id, this.activeProduct.name,
      this.itemsToDownload, "", this.modal, this.dataService, this.siService);
  }

  toggleExportMenu():void {
    setTimeout(() => {
      this.isExportBtnClicked = !this.isExportBtnClicked;
    }, 0);
  }

  exportMetadataAsCSV():void {
    const sub: Subscription =
    this.modal.open(ModalMessageComponent, {
      data: {
              title: $localize`Export metadata`,
              message: $localize`Metadata on the selected items will be downloaded as a CSV file. Download the metadata?`,
              primaryBtn: $localize`Download`,
              secondaryBtn: $localize`Cancel`,
              width: '350px'
            },
      id: 'otsc-products-export-metadata-csv-msg'
      }
    ).afterClosed.subscribe((isPrimaryBtnClicked:boolean) => {
      if(isPrimaryBtnClicked){
        this.exportMetadata('CSV');
      }
      sub.unsubscribe();
    });
  }

  exportMetadataAsWebPage():void {
    const sub: Subscription =
    this.modal.open(ModalMessageComponent, {
      data: {
              title: $localize`Export metadata`,
              message: $localize`Metadata on the selected items will be downloaded as a web page. Download the metadata?`,
              primaryBtn: $localize`Download`,
              secondaryBtn: $localize`Cancel`,
              width: '350px'
            },
      id: 'otsc-products-export-metadata-webpage-msg'
      }
    ).afterClosed.subscribe((isPrimaryBtnClicked:boolean) => {
      if(isPrimaryBtnClicked){
        this.exportMetadata('HTML');
      }
      sub.unsubscribe();
    });
  }

  private exportMetadata(type: 'CSV' | 'HTML'): void {
    let patchList:PatchExt[] = [];
    let langpackList:LanguagePack[] =[];
    if(this.activeProduct.isMultiComponent){
      this.componentTableRows.forEach((component: any) => {
        patchList.push(component.data.patch);
      });
    } else {
      if ((this.activeUpdate.isSupportHotfix && this.activeUpdate.status !== 'INSTALLED') ||
        !this.activeUpdate.isSupportHotfix) {
        patchList.push(this.activeUpdate);
      }

      this.hotfixTableRows.forEach((row: DataTableRow) => {
        if (row.selected) {
          patchList.push(row.data.patch);
        }
      });

      this.langPackTableRows.forEach((row: DataTableRow) => {
        if (row.selected) {
          langpackList.push(row.data.langPack);
        }
      });
    }

    this.siService.exportToFile(patchList, langpackList, type).pipe(
      tap(resp => {
        let msg:MsgPayLoad;

        if(resp.body.status && resp.body.status.success){
          msg = new MsgPayLoad(undefined,{
            message: $localize`Metadata was exported successfully. Please check your download folder.` 
          });
          msg.setEvent(Events.SuccessMsg);
          setTimeout(() => {
            window.open(resp.body.result.data.url, "_self");
          }, 500);
        }else{
          msg = new MsgPayLoad(undefined,{
            message: $localize`Metadata failed to exported. See the log for details.`
          });
          msg.setEvent(Events.ErrorMsg);
        }
        
        Utils.addHeaderMessageBanner(this.eventService, msg);
      })).subscribe();
  }

  private updateItemsToDownload(row:DataTableRow){
    if(row.selected){
      if(row.data.langPack){
        this.itemsToDownload.addDownloadedLangPack(row.data.langPack);
      }else if(row.data.patch){
        this.itemsToDownload.addDownloadedPatches(row.data.patch);
      }
    }else{
      if(row.data.langPack){
        this.itemsToDownload.removeDownloadedLangPack(row.data.langPack);
      }else if(row.data.patch){
        this.itemsToDownload.removeDownloadedPatches(row.data.patch);
      }
    }
  }

  private setLangPackDownloadComplete(downloadedLangpack:LanguagePack, status:string): void {
    let rows:DataTableRow[] = this.langPackTableRows.filter((langRow:DataTableRow) => {
      return downloadedLangpack.binaryuid == langRow.data.langPack.binaryuid;
    });

    if(rows.length > 0){
      rows[0].disableCheckbox = (status === 'COMPLETE' || status === 'INSTALLED') ? true : false;
      rows[0].selected = false;
      rows[0].data.langPack.status = status;
      rows[0].data.status = Utils.getDownloadStatus(rows[0].data.langPack);
    }
  }

  private setLangPackDownloadCompleteByBUId(binaryuid:string, status:string): void {
    let rows:DataTableRow[] = this.langPackTableRows.filter((langRow:DataTableRow) => {
      return binaryuid == langRow.data.langPack.binaryuid;
    });

    if(rows.length > 0){
      rows[0].disableCheckbox = (status === 'COMPLETE' || status === 'INSTALLED') ? true : false;
      rows[0].selected = false;
      rows[0].data.langPack.status = status;
      rows[0].data.status = Utils.getDownloadStatus(rows[0].data.langPack);
    }
  }
  
  private setPatchDownloadComplete(patch:PatchExt, status:string): void {
    let rows:DataTableRow[] = this.hotfixTableRows.filter((hotfixRow:DataTableRow) => {
      return patch.details.binaryuid == hotfixRow.data.patch.details.binaryuid;
    });

    if(rows.length > 0){
      rows[0].disableCheckbox = (status === 'COMPLETE' || status === 'INSTALLED') ? true : false;
      rows[0].selected = false;
      rows[0].data.patch.status = status;
      rows[0].data.status = Utils.getDownloadStatus(rows[0].data.patch);
      rows[0].actions.push(new ActionMenuItem("Delete", $localize`Delete`, ActionMenuIcon.DELETE, {patch: patch}, true, true));
      this.setSupersededInfo();
    }
  }

  private setPatchDownloadCompleteByBUId(binaryuid:string, status:string): void {
    let rows:DataTableRow[] = this.hotfixTableRows.filter((hotfixRow:DataTableRow) => {
      return binaryuid == hotfixRow.data.patch.details.binaryuid;
    });

    if(rows.length > 0){
      rows[0].disableCheckbox = (status === 'COMPLETE' || status === 'INSTALLED') ? true : false;
      rows[0].selected = false;
      rows[0].data.patch.status = status;
      rows[0].data.status = Utils.getDownloadStatus(rows[0].data.patch);
      rows[0].actions.push(new ActionMenuItem("Delete", $localize`Delete`, ActionMenuIcon.DELETE, {patch: rows[0].data.patch}, true, true));
      this.setSupersededInfo();
    }
  }

  private setComponentPatchDownloadComplete(patch: PatchExt, status: string): void {
    let rows: DataTableRow[] = this.componentTableRows.filter((componentRow: DataTableRow) => {
      return patch.details.binaryuid == componentRow.data.patch.details.binaryuid;
    });

    if (rows.length > 0) {
      rows[0].disableCheckbox = (status === 'COMPLETE' || status === 'INSTALLED') ? true : false;
      rows[0].selected = false;
      rows[0].data.patch.status = status;
      rows[0].data.status = Utils.getDownloadStatus(rows[0].data.patch);
      this.setComponentOverallDownloadStatus(this.activeProduct, rows[0].data.patch.patchLevel);
    }
  }

  private setUpdateDownloadComplete(msg: any){
    let patches: PatchExt[] = this.availablePatches.filter((patch: PatchExt)=>{
      return patch.binaryUid == msg.binaryuid;
    });

    if(patches.length > 0){
      this.itemsToDownload.removeDownloadedUpdatesByBId(msg.binaryuid);
      patches[0].status = msg.status;
      if(this.activeUpdate.binaryUid == msg.binaryuid){
        this.activeUpdate.status = msg.status;
        this.summaryStatus = msg.status;
      }
    }
  }

  private setDownloadInProgress(): void {

    if(this.activeUpdate && this.activeUpdate.isSupportHotfix){
      this.itemsToDownload.patches.forEach((hotfix:PatchExt) => {
        let rows:DataTableRow[] = this.hotfixTableRows.filter((hotfixRow:DataTableRow) => {
          return hotfix.name == hotfixRow.data.patch.name;
        });

        if(rows.length > 0){
          rows[0].disableCheckbox = true;
          rows[0].data.patch.status = 'DOWNLOAD';
          rows[0].data.status = Utils.getDownloadStatus(rows[0].data.patch);
        }
      });

      this.itemsToDownload.languages.forEach((langPack:LanguagePack) => {
        let rows:DataTableRow[] = this.langPackTableRows.filter((langRow:DataTableRow) => {
          return langPack.binaryuid == langRow.data.langPack.binaryuid;
        });

        if(rows.length > 0){
          rows[0].disableCheckbox = true;
          rows[0].data.langPack.status = 'DOWNLOAD';
          rows[0].data.status = Utils.getDownloadStatus(rows[0].data.langPack);
        }
      });
    } else {
      this.itemsToDownload.patches.forEach((componentUpdate: PatchExt) => {
        let rows: DataTableRow[] = this.componentTableRows.filter((componentRow: DataTableRow) => {
          return componentUpdate.binaryUid == componentRow.data.patch.binaryUid;
        });

        if (rows.length > 0) {
          rows[0].disableCheckbox = true;
          rows[0].data.patch.status = 'DOWNLOAD';
          rows[0].data.status = Utils.getDownloadStatus(rows[0].data.patch);
          this.summaryStatus = rows[0].data.patch.status;
        }
      });
    }

    if(this.activeUpdate && this.itemsToDownload.updates.length > 0 && this.activeUpdate.status !== 'INSTALLED'){
      this.activeUpdate.status = 'DOWNLOAD';
      this.summaryStatus = this.activeUpdate.status;
    }

    Utils.showDownloadStartedDialog(DownloadType.PRODUCT, this.itemsToDownload.getTotalItems(), this.modal, this.cookieSrv);
  }

  private initActiveUpdate(isLoadHotfix:boolean):void {
    let update: PatchExt;
    let updateIndex: number = 0;

    let foundUpdate = this.availablePatches.filter((patch: PatchExt, index: number) => {
      if (patch.details && (patch.details.binaryuid == this.binaryuid)) {
        updateIndex = index;
        return patch;
      }
    });
    
    if (foundUpdate.length > 0) {
      update = foundUpdate[0];

      //set update binaryUid for langpacks from downloaded patches
      if(update.details && update.details.languagePackList && update.details.languagePackList.length > 0){
        update.details.languagePackList.forEach((langpack) => {
          langpack.updateBinaryUID = update.details.binaryuid;
        });
      }
    }

    if (update) {
      this.availablePatches.forEach((update: PatchExt, index: number) => {
        if (index == 0 && this.activeProduct.supportHotfix) {
          update.status = 'INSTALLED';
          //show installed update as downloaded
        } else if (update.status == 'INSTALLED') {
          update.status = 'COMPLETE';
        }
      });

      if(this.downloadedPatches != undefined && this.downloadedPatches.length > 0){
          let foundPatches: PatchExt[] = (this.downloadedPatches.filter((downloadedPatch:PatchExt) => {
            return update.details.binaryuid == downloadedPatch.details.binaryuid;
          }));
          if(foundPatches != undefined && foundPatches.length > 0 && update.status !== 'INSTALLED'){
            update.status = "COMPLETE";
          }
      }

      this.setActiveUpdate(update, this.activeProduct.supportHotfix && updateIndex === 0);

      if(this.activeProduct.supportHotfix && isLoadHotfix){
        this.requestFailed = false;
      }
    } else {
      this.router.navigate(['products/overview']);
    }
  }

  private setActiveUpdate(update:PatchExt, isCurrentUpdate: boolean): void {
    this.activeUpdate = update;
    this.summaryStatus = this.activeUpdate.status;
    this.summaryVersion = this.activeUpdate.isSupportHotfix ? this.activeUpdate.name : this.activeUpdate.patchLevel;
    this.summaryZeroDowntime = this.activeUpdate.supportsZeroDowntime;
    this.activeTab = UpdateTab.PATCHES;
    this.overrideHotfixSelectAll = false;
    this.availableUpdates = [];
    this.langPackTableRows = [];
    this.languageTab.count = 0;
    this.patchesTab.count = 0;
    this.resetItemsToDownload();

    if (!isCurrentUpdate && update.status !== 'COMPLETE') {
      this.itemsToDownload.updates.push(update);
    }

    if(this.activeUpdate.details){
      this.headerTitle = this.activeUpdate.name;
      this.summaryDescription = this.activeUpdate.details.description;
      this.summarySize = this.activeUpdate.details.size;
      this.summaryReleaseDate = this.activeUpdate.details.publishDate;
    }

    if(this.activeUpdate.details && this.activeUpdate.details.languagePackList && this.quickAnalysisResult){
      this.activeUpdate.details.languagePackList.forEach((langpack: LanguagePack) => {
        let isDownloaded:boolean = langpack.status === 'COMPLETE' || langpack.status === 'INSTALLED';
        let actionMenus = [new ActionMenuItem("Details", $localize`Details`, ActionMenuIcon.DETAILS, langpack, false, true)];
        let isInstalledLangPack = this.quickAnalysisResult.langCodes.findIndex(langCode => langCode === langpack.langCode) > -1 ? true : false;
        if(isDownloaded || langpack.status === 'ERROR'){
          actionMenus.push(new ActionMenuItem("Delete", $localize`Delete`, ActionMenuIcon.DELETE, {langPack: langpack}, false, true));
        }

        let langPackRow = new DataTableRow({langName: langpack.langName, langCode: langpack.langCode, 
                                          status: Utils.getDownloadStatus(langpack), url: langpack.downloadURL, langPack: langpack}, 
                                          actionMenus, false, 
                                          (!isCurrentUpdate && !isDownloaded && isInstalledLangPack));
        langPackRow.disableCheckbox = (isDownloaded || (isCurrentUpdate && isInstalledLangPack));
        //langpack is installed on the current update
        if(isCurrentUpdate && isInstalledLangPack){
          langPackRow.data.status = {className: 'otsc-icon-status-prev-download', altText: $localize`Previously downloaded`};
        }
        this.langPackTableRows.push(langPackRow);

        if(langPackRow.selected){
          this.itemsToDownload.languages.push(langpack);
        }
      });
      this.languageTab.count = this.langPackTableRows.length;
    }
  }

  private resetItemsToDownload(): void {
    this.itemsToDownload.patches = [];
    this.itemsToDownload.updates = [];
    this.itemsToDownload.languages = [];
  }

  private initTableCols():void {
    if (this.supportsZeroDowntime) {
      this.hotfixTableCols = this.isOnlineMode ? Array<DataTableColumn>(
        new DataTableColumn("name", $localize`Name`, ColumnType.STRING, false, "12"),
        new DataTableColumn("description", $localize`Description`, ColumnType.STRING, false, "42"),
        new DataTableColumn("modules", $localize`Modules`, ColumnType.STRING, false, "28"),
        new DataTableColumn("zero", $localize`Zero Downtime`, ColumnType.STRING, false, "10"),
        new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "8")
      ) :
        Array<DataTableColumn>(
          new DataTableColumn("name", $localize`Name`, ColumnType.STRING, false, "12"),
          new DataTableColumn("description", $localize`Description`, ColumnType.STRING, false, "40"),
          new DataTableColumn("modules", $localize`Modules`, ColumnType.STRING, false, "26"),
          new DataTableColumn("zero", $localize`Zero Downtime`, ColumnType.STRING, false, "10"),
          new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "6"),
          new DataTableColumn("url", $localize`URL`, ColumnType.DOWNLOADLINK, false, "6")
        );
    } else {
      this.hotfixTableCols = this.isOnlineMode ? Array<DataTableColumn>(
        new DataTableColumn("name", $localize`Name`, ColumnType.STRING, false, "14"),
        new DataTableColumn("description", $localize`Description`, ColumnType.STRING, false, "46"),
        new DataTableColumn("modules", $localize`Modules`, ColumnType.STRING, false, "30"),
        new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "10")
      ) :
        Array<DataTableColumn>(
          new DataTableColumn("name", $localize`Name`, ColumnType.STRING, false, "14"),
          new DataTableColumn("description", $localize`Description`, ColumnType.STRING, false, "44"),
          new DataTableColumn("modules", $localize`Modules`, ColumnType.STRING, false, "29"),
          new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "7"),
          new DataTableColumn("url", $localize`URL`, ColumnType.DOWNLOADLINK, false, "6")
        );
    }

    this.langPackTableCols = this.isOnlineMode ? Array<DataTableColumn>(new DataTableColumn("langName", $localize`Name`, ColumnType.STRING, false, "48"),
      new DataTableColumn("langCode", $localize`Code`, ColumnType.STRING, false, "26"),
      new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "26")
    ) :
      Array<DataTableColumn>(new DataTableColumn("langName", $localize`Name`, ColumnType.STRING, false, "48"),
        new DataTableColumn("langCode", $localize`Code`, ColumnType.STRING, false, "26"),
        new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "18"),
        new DataTableColumn("url", $localize`URL`, ColumnType.DOWNLOADLINK, false, "8")
      );

    this.componentTableCols = this.isOnlineMode ? Array<DataTableColumn>(new DataTableColumn("name", $localize`Name`, ColumnType.STRING, false, "48"),
      new DataTableColumn("version", $localize`Version`, ColumnType.STRING, false, "21"),
      new DataTableColumn("size", $localize`Size`, ColumnType.STRING, false, "16"),
      new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "15")
    ) :
      Array<DataTableColumn>(new DataTableColumn("name", $localize`Name`, ColumnType.STRING, false, "41"),
        new DataTableColumn("version", $localize`Version`, ColumnType.STRING, false, "21"),
        new DataTableColumn("size", $localize`Size`, ColumnType.STRING, false, "15"),
        new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "15"),
        new DataTableColumn("url", $localize`URL`, ColumnType.DOWNLOADLINK, false, "8"));
  }

  private initView():void {
    this.availablePatches = [];
    this.currEnvId = this.solutionInfo.currentEnvironment.id;
    this.isExportBtnClicked = false;
    let foundDiscoveredProductGroup:DiscoveredProduct[] = [];

    this.siService.getProductDetail(this.currEnvId, this.platform, this.productId).pipe(
      tap(resp => {
        this.activeProduct = resp.body;
        this.downloadedPatches = this.activeProduct.downloadedPatches;

        foundDiscoveredProductGroup = this.discoveredProduct.filter((dProduct: DiscoveredProduct) => {
          return dProduct.groupId == this.productGroupId;
        });

        if (foundDiscoveredProductGroup.length > 0) {
          this.isMasterSystemSelected = true;

          for (let i = 0; i < foundDiscoveredProductGroup[0].products.length; i++) {
            if (foundDiscoveredProductGroup[0].products[i].id == this.productId) {
              this.activeProduct = foundDiscoveredProductGroup[0].products[i];
              this.availablePatches = this.activeProduct.availablePatches;
              break;
            }
          }

          this.isQuickAnalysisRequired = this.activeProduct.supportHotfix && !this.activeProduct.isQuickAnalysisValid;
          this.productDetailsTitle = $localize`Download Updates for ${this.activeProduct.name}`;
          this.dataService.sendData({type: ProductDataType.Title, title: this.productDetailsTitle});
          this.productId = this.activeProduct.id;
          this.setupId = this.activeProduct.components[0].setupid;

          if (this.activeProduct.supportHotfix && this.activeProduct.isMasterSystemOnline) {
            //check the master instance
            let masterSystemCounter: number = 0;
            for (let key in this.activeProduct.instances) {
              this.activeProduct.instances[key].forEach((instance: ProductInstance) => {
                if (instance.isMasterInstance) {
                  masterSystemCounter++;
                  this.host = this.host == undefined ? key : this.host;
                }
              });
            }
            this.isMasterSystemSelected = masterSystemCounter == 1;
          } else if (this.agents) {
            let onlineAgent: Agent[] = this.agents.filter((agent: Agent) => { return agent.isOnline });

            if (onlineAgent.length > 0) {
              this.host = onlineAgent[0].macAddress;
            }
          }

          if (this.availablePatches.length > 0 && !this.activeProduct.isMultiComponent) {
            this.initActiveUpdate(true);
          }
        } else {
          this.router.navigate(['products/overview']);
        }
        this.isLoading = this.isAgentOnline && this.activeProduct.patchableData.isRequestingPatches;
      })).subscribe();

  }

  private openDetails(pkg: any){
    this.modal.open(ObjectDetailsComponent, {
      data: { 
        obj: pkg.patch ? pkg.patch : pkg, 
        type: (pkg.langCode == undefined) ? ObjectDetailsTypes.PATCH : ObjectDetailsTypes.LANG_PACK },
      id: (pkg.langCode == undefined) ? 'otsc-products-patch-details-dialog' : 'otsc-products-langpack-details-dialog'
    });
  }

  private rowClick(event: any): void {
    this.openDetails((event.data.langPack == undefined) ? event.data : event.data.langPack);
  }

  private resetComponentInformation(): void {
    this.componentTableRows = [];
    this.resetItemsToDownload();
  }

  private loadComponentVersions(product: ProductExt): void {
    product.availablePatches.forEach((patch: PatchExt) => {
      if(patch.details.binaryuid == this.binaryuid){
        this.setActiveComponentVersion(patch.patchLevel);
      }
    });
  }

  private loadComponentPatchInformation(product: ProductExt, version: string): void {
    this.componentsLoading = true;
    this.componentTableRows = [];
    this.resetItemsToDownload();
    let tmpSize: number = 0;
    let tmpDate: string = "";

    product.components.forEach((component: any) => {
      let foundPatch = product.availablePatches.filter((patch: PatchExt) => {
        return patch.setupId == component.setupid && patch.patchLevel == version;
      });
      if (foundPatch && foundPatch.length == 1) {
        this.headerTitle = foundPatch[0].name;
        this.summaryZeroDowntime = foundPatch[0].supportsZeroDowntime;
        let isValidDownloadURL: boolean = foundPatch[0].details.downloadURL && foundPatch[0].details.downloadURL !== '';
        let isDownloaded: boolean = foundPatch[0].status === 'COMPLETE' || foundPatch[0].status === 'INSTALLED';
        let actionMenus: ActionMenuItem[] = [new ActionMenuItem("Details", $localize`Details`, ActionMenuIcon.DETAILS, foundPatch[0], false, true)];

        let row = new DataTableRow({
          name: component.name,
          version: foundPatch[0].patchLevel,
          size: foundPatch[0].details.size,
          status: Utils.getDownloadStatus(foundPatch[0]),
          url: foundPatch[0].details.downloadURL,
          patch: foundPatch[0]
        },
          actionMenus, false,
          !isDownloaded && isValidDownloadURL ? true : false,
          false);
        if (isDownloaded || !isValidDownloadURL) {
          row.disableCheckbox = true;
        }
        tmpDate = foundPatch[0].details.publishDate;
        tmpSize += foundPatch[0].details.byteSize;

        if(foundPatch[0].status !== "COMPLETE"){
          this.itemsToDownload.patches.push(foundPatch[0]);
        }
        this.componentTableRows.push(row);
      }
    });

    this.setComponentOverallDownloadStatus(product, version);
    this.summaryReleaseDate = tmpDate;
    this.summaryDescription = '';
    this.summaryVersion = version;
    this.summarySize = new FileSizePipe().transform(tmpSize);
    this.componentTab.count = this.componentTableRows.length;
    this.overrideHotfixSelectAll = true;
    this.componentsLoading = false;
    this.hotfixLoading = false;
    this.isLoading = false;
  }

  private setComponentOverallDownloadStatus(product: ProductExt, version: string): void {
    let numDownloading: number = 0;
    let numDownloaded: number = 0;
    let numErrorDownload: number = 0;
    let numInstalled: number = 0;
    let numAvailable: number = 0;
    let totalDownload: number = 0;
    
    product.components.forEach((component: any) => {
      let foundPatch = product.availablePatches.filter((patch: PatchExt) => {
        return patch.setupId == component.setupid && patch.patchLevel == version;
      });
      if (foundPatch && foundPatch.length == 1) {
        if (foundPatch[0].status === 'COMPLETE') {
          numDownloaded++;
        } else if (foundPatch[0].status === 'INSTALLED') {
          numInstalled++;
        } else if (foundPatch[0].status === 'AVAILABLE') {
          numAvailable++;
        } else if (foundPatch[0].status === 'ERROR') {
          numErrorDownload++;
        } else {
          numDownloading++;
        }
        totalDownload++;
      }
    });

    if (numDownloading > 0) {
      this.summaryStatus = '';
    } else if (numDownloaded == totalDownload) {
      this.summaryStatus = 'COMPLETE';
    } else if (numInstalled == totalDownload) {
      this.summaryStatus = 'INSTALLED';
    } else if (numDownloading == 0 && numErrorDownload == 0 && numAvailable > 0) {
      this.summaryStatus = 'AVAILABLE';
    } else if (numDownloading == 0 && numErrorDownload > 0) {
      this.summaryStatus = 'ERROR';
    }
  }

  setActiveComponentVersion(version: string){
    this.activeUpdate = undefined;
    this.selectedComponentVersion = version;
    this.activeComponent = this.selectedComponentVersion;
    this.loadComponentPatchInformation(this.activeProduct, this.activeComponent);
  }

  selectAllComponents(rows: DataTableRow[]): void {
    rows.forEach((row: DataTableRow) => {
      this.updateItemsToDownload(row);
    });
  }

  componentRowChecked(row: DataTableRow): void {
    this.updateItemsToDownload(row);
  }

  canDeactivate() : boolean{
    return !this.isLoading
  }

  getDeactivateModalMessageConfig(): ModalConfig {
    let deactivationModalMsg: ModalConfig = {
                  data: {
                        title: $localize`Warning`,
                        message: $localize`Please wait while data is loading...`,
                        primaryBtn: $localize`Wait`,
                        secondaryBtn: $localize`Leave`,
                        width: '400px',
                        type: ModalMessageType.Warning,
                  },
                  id: 'otsc-product-updates-loading-warning',
                  closeOnESCKeyUp: false
            }
    return deactivationModalMsg;
  }

  openOfflineDownloadLink(url:string): void {
    window.open(url, "_blank");
  }

  getAvailableHotfixes():void {
    if(this.host && this.activeProduct != undefined && this.activeProduct.supportHotfix && !this.isRequestingHotfixes){
      this.isRequestingHotfixes = true;
      this.hotfixLoading = true;
      this.hotfixTableRows = [];
      this.siService.sendGetAvailableHotfixes(this.wsService.getClientId(), this.wsService.getWSEnvId(), 
          this.addTransaction(), new AvailableHotfixRequest(this.host, this.activeProduct.patchableData.plugin,
            this.activeProduct.patchableData.productInfo.setupId,
            this.activeUpdate.productGroupId, this.activeUpdate, this.activeProduct.platform)).pipe(
            tap(resp => {
          }),
          catchError(resp => {
            this.requestErrorMessage = TranslationUtils.getTaskErrorMessage("HOTFIXES_AVAILABLE", undefined);
            this.requestFailed = true;
            this.hotfixLoading = false;
            return of(resp);
          })).subscribe();
    }else{
      if(!this.host || this.activeProduct == undefined){
        setTimeout(() => {
          this.getAvailableHotfixes();
        }, 200);
      }
    }
  }
}
